import React from "react";
import Content from "./Content";
import ReactHtmlParser from "react-html-parser";
import slugify from "slugify";
import "twin.macro";
import TableOfContents from "./TableOfContents";

function getTitle(node) {
  const { data } = node.children[0];
  if (typeof data === "string") return data;
  else return getTitle(node.children[0]);
}

const PageContent = ({ content, article }) => {
  const tableOfContents = [];
  let tableFound = false;
  const components = ReactHtmlParser(content, {
    transform: (node, i) => {
      if (node.type !== "tag") return;

      if (node.attribs.class === "custom-blocks__table-of-contents") {
        tableFound = true;
        return <TableOfContents table={tableOfContents} />;
      } else if (node.name === "h2") {
        // Ignore H2s above the first table of contents
        // block.
        if (!tableFound) return;

        const title = getTitle(node);
        if (node.attribs.id) {
          tableOfContents.push({ title, id: node.attribs.id });
        } else {
          const id = slugify(title);
          tableOfContents.push({ id, title });
          return (
            <h2 id={id} {...node.attribs}>
              {title}
            </h2>
          );
        }
      }
    },
  });
  return <Content article={article}>{components}</Content>;
};

export default PageContent;
